(function () {
  // Mobil menü
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Ana menü açılır listeleri (ör. "Tüm Ürünler") — dışarıya tıklayınca kapat
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.site-nav details.has-dropdown[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.site-nav details.has-dropdown[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  });

  // Arama çubuğu
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var open = searchBar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) searchBar.querySelector('input').focus();
    });
  }

  // Ürün galerisi — kaydırmalı (swipe) slider
  var track = document.querySelector('[data-gallery-track]');
  if (track) {
    var slides = track.querySelectorAll('[data-gallery-slide]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var dots = document.querySelectorAll('[data-gallery-dot]');

    function goTo(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
    }
    function currentIndex() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function setActive(index) {
      thumbs.forEach(function (b, i) { b.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { setActive(currentIndex()); }, 60);
    }, { passive: true });

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { goTo(i); });
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });

    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex() - 1); }
    });
  }

  document.querySelectorAll('[data-card-slider]').forEach(function (slider) {
    var cTrack = slider.querySelector('[data-card-track]');
    var cDots = slider.querySelectorAll('.card-slider__dots span');
    if (!cTrack) return;

    function cIndex() { return Math.round(cTrack.scrollLeft / cTrack.clientWidth); }
    function cGo(i, e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var max = cTrack.children.length - 1;
      i = Math.max(0, Math.min(i, max));
      cTrack.scrollTo({ left: cTrack.clientWidth * i, behavior: 'smooth' });
    }

    var cTimer;
    cTrack.addEventListener('scroll', function () {
      clearTimeout(cTimer);
      cTimer = setTimeout(function () {
        var i = cIndex();
        cDots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }, 60);
    }, { passive: true });

    var cPrev = slider.querySelector('[data-card-prev]');
    var cNext = slider.querySelector('[data-card-next]');
    if (cPrev) cPrev.addEventListener('click', function (e) { cGo(cIndex() - 1, e); });
    if (cNext) cNext.addEventListener('click', function (e) { cGo(cIndex() + 1, e); });
  });

  var variantSelect = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-price]');
  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (opt.dataset.price) priceEl.textContent = opt.dataset.price;
      var addBtn = document.querySelector('[data-add-to-cart]');
      if (addBtn) {
        var available = opt.dataset.available === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
      }
    });
  }

  // Ürün sayfası formu: AJAX ile sepete ekle, sayfa yönlenmesin.
  // Ekleme başarılı olunca "Alışverişe devam et / Sepete git" seçenekli popup açılır.
  var pdpForm = document.querySelector('.product-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = pdpForm.querySelector('[data-add-to-cart]');
      if (addBtn && addBtn.disabled) return;
      var originalLabel = addBtn ? addBtn.textContent : '';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Ekleniyor...'; }

      var formData = new FormData(pdpForm);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (item) {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalLabel; }

          // sepet sayacını güncelle
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var link = document.querySelector('a[href$="/cart"]');
              if (!link) return;
              var badge = link.querySelector('.cart-count');
              if (cart.item_count > 0) {
                if (!badge) {
                  badge = document.createElement('span');
                  badge.className = 'cart-count';
                  link.appendChild(badge);
                }
                badge.textContent = cart.item_count;
              } else if (badge) {
                badge.remove();
              }
            });

          // "sepete eklendi" popup'ını göster
          var popup = document.querySelector('[data-cart-added-popup]');
          if (popup) {
            var titleEl = popup.querySelector('[data-cart-added-title]');
            if (titleEl) titleEl.textContent = item.product_title || item.title || 'Ürün';
            popup.hidden = false;
          }
        })
        .catch(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalLabel; }
          alert('Ürün sepete eklenemedi, tekrar dener misin?');
        });
    });
  }

  // "Sepete eklendi" popup'ı — kapatma / devam etme
  var cartAddedPopup = document.querySelector('[data-cart-added-popup]');
  if (cartAddedPopup) {
    var continueBtn = cartAddedPopup.querySelector('[data-cart-added-continue]');
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        cartAddedPopup.hidden = true;
      });
    }
    cartAddedPopup.addEventListener('click', function (e) {
      if (e.target === cartAddedPopup) cartAddedPopup.hidden = true;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !cartAddedPopup.hidden) cartAddedPopup.hidden = true;
    });
  }
})();

// Hızlı sepete ekle
(function () {
  var TICK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4 10-10"/></svg>';

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.querySelector('a[href$="/cart"]');
        if (!link) return;
        var badge = link.querySelector('.cart-count');
        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'cart-count';
            link.appendChild(badge);
          }
          badge.textContent = cart.item_count;
        } else if (badge) {
          badge.remove();
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var original = btn.innerHTML;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-busy');
        updateCartCount();
        maybeShowNewsletterPopup();
        var stepper = btn.parentNode.querySelector('[data-quick-stepper]');
        if (stepper) {
          openStepper(btn, stepper);
        } else {
          btn.classList.add('is-added');
          btn.innerHTML = TICK;
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.innerHTML = original;
          }, 1600);
        }
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.innerHTML = original;
      });
  });

  function closeStepper(stepper) {
    clearTimeout(stepper._idleTimer);
    stepper.hidden = true;
    var addBtn = stepper.parentNode.querySelector('[data-quick-add]');
    if (addBtn) addBtn.hidden = false;
  }
  function armIdle(stepper) {
    clearTimeout(stepper._idleTimer);
    stepper._idleTimer = setTimeout(function () { closeStepper(stepper); }, 3500);
  }
  function openStepper(btn, stepper) {
    var variantId = Number(stepper.dataset.variantId);
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = 0;
        cart.items.forEach(function (it) { if (it.variant_id === variantId) qty += it.quantity; });
        stepper.querySelector('[data-qs-qty]').textContent = qty || 1;
        btn.hidden = true;
        stepper.hidden = false;
        armIdle(stepper);
      });
  }

  document.addEventListener('click', function (e) {
    var stepper = e.target.closest('[data-quick-stepper]');
    if (!stepper) return;
    e.preventDefault();
    e.stopPropagation();

    var qsBtn = e.target.closest('[data-qs-minus], [data-qs-plus]');
    if (!qsBtn) { armIdle(stepper); return; }
    if (stepper._busy) return;

    var qtyEl = stepper.querySelector('[data-qs-qty]');
    var qty = parseInt(qtyEl.textContent, 10) || 0;
    var next = qty + (qsBtn.hasAttribute('data-qs-plus') ? 1 : -1);
    if (next < 0) next = 0;

    stepper._busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(stepper.dataset.variantId), quantity: next })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return r.json();
      })
      .then(function () {
        stepper._busy = false;
        qtyEl.textContent = next;
        updateCartCount();
        if (next === 0) { closeStepper(stepper); } else { armIdle(stepper); }
      })
      .catch(function () {
        stepper._busy = false;
        armIdle(stepper);
      });
  });

  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!stepBtn) return;
    var stepper = stepBtn.closest('[data-qty-stepper]');
    var input = stepper && stepper.querySelector('.qty-input');
    if (!input) return;

    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = min;

    val += stepBtn.hasAttribute('data-qty-plus') ? 1 : -1;
    if (val < min) val = min;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: currency || 'TRY' }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2);
    }
  }

  function updateShippingBar(cart) {
    var bar = document.querySelector('[data-shipping-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10);
    if (isNaN(threshold)) return;
    var textEl = bar.querySelector('[data-shipping-text]');
    var fillEl = bar.querySelector('[data-shipping-fill]');
    var subtotal = cart.items_subtotal_price;
    var remaining = threshold - subtotal;
    var pct = Math.max(0, Math.min(100, (subtotal / threshold) * 100));
    if (fillEl) fillEl.style.width = pct + '%';
    if (remaining > 0) {
      bar.classList.remove('is-complete');
      if (textEl) textEl.innerHTML = 'Ücretsiz kargoya <strong>' + formatMoney(remaining, cart.currency) + '</strong> kaldı! 🚚';
    } else {
      bar.classList.add('is-complete');
      if (textEl) textEl.textContent = 'Tebrikler, kargon ücretsiz! 🎉';
    }
  }

  function applyCartUpdate(input, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: input.dataset.key, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return r.json();
      })
      .then(function (cart) {
        if (cart.item_count === 0) { window.location.reload(); return; }

        var row = input.closest('tr');
        var item = null;
        cart.items.forEach(function (it) { if (it.key === input.dataset.key) item = it; });

        if (!item) {
          if (row) row.remove();
        } else {
          input.value = item.quantity;
          input.dataset.prev = item.quantity;
          var totalCell = row && row.querySelector('[data-line-total]');
          if (totalCell) totalCell.textContent = formatMoney(item.final_line_price, cart.currency);
        }

        var subtotalEl = document.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price, cart.currency);
        updateShippingBar(cart);
        updateCartCount();
      })
      .catch(function () {});
  }

  var confirmOverlay = document.querySelector('[data-cart-confirm]');
  var confirmPending = null;

  function openConfirm(input) {
    confirmPending = { input: input };
    var textEl = confirmOverlay && confirmOverlay.querySelector('[data-cart-confirm-text]');
    if (textEl) {
      var name = input.dataset.name || 'Bu ürünü';
      textEl.textContent = '"' + name + '" ürününü sepetten kaldırmak istediğine emin misin?';
    }
    if (confirmOverlay) confirmOverlay.hidden = false;
  }
  function closeConfirm() {
    if (confirmOverlay) confirmOverlay.hidden = true;
    confirmPending = null;
  }

  if (confirmOverlay) {
    var okBtn = confirmOverlay.querySelector('[data-cart-confirm-ok]');
    var cancelBtn = confirmOverlay.querySelector('[data-cart-confirm-cancel]');

    if (okBtn) okBtn.addEventListener('click', function () {
      if (!confirmPending) return;
      var input = confirmPending.input;
      closeConfirm();
      applyCartUpdate(input, 0);
    });
    if (cancelBtn) cancelBtn.addEventListener('click', function () {
      if (!confirmPending) return;
      var input = confirmPending.input;
      var prev = parseInt(input.dataset.prev, 10);
      input.value = isNaN(prev) || prev < 1 ? 1 : prev;
      closeConfirm();
    });
    confirmOverlay.addEventListener('click', function (e) {
      if (e.target === confirmOverlay && cancelBtn) cancelBtn.click();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && confirmOverlay && !confirmOverlay.hidden && cancelBtn) cancelBtn.click();
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('.qty-input[data-key]');
    if (!input) return;

    clearTimeout(input._syncTimer);
    input._syncTimer = setTimeout(function () {
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;

      if (qty === 0) {
        openConfirm(input);
        return;
      }

      applyCartUpdate(input, qty);
    }, 300);
  });
})();

// İlk siparişe %10 e-posta popup'ı
(function () {
  var DONE_KEY = 'atolyeNewsletterDone';
  var overlay = document.querySelector('[data-newsletter-popup]');
  if (!overlay) return;

  var formWrap = overlay.querySelector('[data-newsletter-form-wrap]');
  var form = overlay.querySelector('[data-newsletter-form]');
  var emailInput = overlay.querySelector('[data-newsletter-email]');
  var errorEl = overlay.querySelector('[data-newsletter-error]');
  var successEl = overlay.querySelector('[data-newsletter-success]');
  var submitBtn = overlay.querySelector('[data-newsletter-submit]');
  var closeBtn = overlay.querySelector('[data-newsletter-close]');
  var copyBtn = overlay.querySelector('[data-newsletter-copy]');

  function isDone() {
    try { return localStorage.getItem(DONE_KEY) === '1'; } catch (err) { return false; }
  }
  function markDone() {
    try { localStorage.setItem(DONE_KEY, '1'); } catch (err) {}
  }

  window.maybeShowNewsletterPopup = function () {
    if (isDone()) return;
    if (!overlay.hidden) return;
    overlay.hidden = false;
  };

  function closePopup(remember) {
    overlay.hidden = true;
    if (remember) markDone();
  }

  if (closeBtn) closeBtn.addEventListener('click', function () { closePopup(true); });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup(true);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closePopup(true);
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.classList.remove('is-visible');
      var email = emailInput.value.trim();
      if (!email) return;

      submitBtn.disabled = true;
      var originalLabel = submitBtn.textContent;
      submitBtn.textContent = 'Gönderiliyor...';

      var body = new URLSearchParams();
      body.set('form_type', 'customer');
      body.set('utf8', '✓');
      body.set('contact[tags]', 'newsletter,popup10');
      body.set('contact[email]', email);

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      })
        .then(function () {
          markDone();
          if (formWrap) formWrap.hidden = true;
          if (successEl) successEl.hidden = false;
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
          if (errorEl) errorEl.classList.add('is-visible');
        });
    });
  }

  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = overlay.querySelector('[data-newsletter-code]').textContent.trim();
      var done = function () {
        var original = copyBtn.textContent;
        copyBtn.textContent = 'Kopyalandı ✓';
        setTimeout(function () { copyBtn.textContent = original; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        done();
      }
    });
  }
})();

// Footer bülten formu
(function () {
  var form = document.querySelector('[data-footer-newsletter-form]');
  if (!form) return;
  var emailInput = form.querySelector('[data-footer-newsletter-email]');
  var submitBtn = form.querySelector('[data-footer-newsletter-submit]');
  var msgEl = document.querySelector('[data-footer-newsletter-msg]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = emailInput.value.trim();
    if (!email) return;
    submitBtn.disabled = true;
    var originalLabel = submitBtn.textContent;
    submitBtn.textContent = 'Gönderiliyor...';

    var body = new URLSearchParams();
    body.set('form_type', 'customer');
    body.set('utf8', '✓');
    body.set('contact[tags]', 'newsletter,footer');
    body.set('contact[email]', email);

    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
      .then(function () {
        form.reset();
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
        if (msgEl) {
          msgEl.textContent = 'Teşekkürler! Abone oldun 🎉';
          msgEl.classList.remove('is-error');
          msgEl.hidden = false;
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
        if (msgEl) {
          msgEl.textContent = 'Bir şeyler ters gitti, tekrar dener misin?';
          msgEl.classList.add('is-error');
          msgEl.hidden = false;
        }
      });
  });
})();

// Stokta yok bildirim formu
(function () {
  var form = document.querySelector('[data-restock-form]');
  if (!form) return;
  var emailInput = form.querySelector('[data-restock-email]');
  var submitBtn = form.querySelector('[data-restock-submit]');
  var msgEl = document.querySelector('[data-restock-msg]');
  var productTitle = form.dataset.productTitle || '';
  var productUrl = form.dataset.productUrl || '';

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = emailInput.value.trim();
    if (!email) return;
    submitBtn.disabled = true;
    var originalLabel = submitBtn.textContent;
    submitBtn.textContent = 'Gönderiliyor...';

    var body = new URLSearchParams();
    body.set('form_type', 'contact');
    body.set('utf8', '✓');
    body.set('contact[email]', email);
    body.set('contact[body]', 'Stok bildirimi talebi — Ürün: ' + productTitle + ' (' + window.location.origin + productUrl + '). Bu ürün tekrar stoğa girdiğinde bu e-posta adresine haber verilmesi isteniyor.');

    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
      .then(function () {
        form.reset();
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
        if (msgEl) {
          msgEl.textContent = 'Teşekkürler! Stoğa girince sana da haber vereceğiz.';
          msgEl.classList.remove('is-error');
          msgEl.hidden = false;
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
        if (msgEl) {
          msgEl.textContent = 'Bir şeyler ters gitti, tekrar dener misin?';
          msgEl.classList.add('is-error');
          msgEl.hidden = false;
        }
      });
  });
})();

// Favoriler (localStorage bazlı — cihaza özel, hesaba bağlı değil)
(function () {
  var KEY = 'atolyeFavorites';

  function getFavorites() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function saveFavorites(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function isFavorite(handle) {
    return getFavorites().indexOf(handle) !== -1;
  }
  function toggleFavorite(handle) {
    var list = getFavorites();
    var idx = list.indexOf(handle);
    if (idx === -1) { list.push(handle); } else { list.splice(idx, 1); }
    saveFavorites(list);
  }
  function syncButtons() {
    document.querySelectorAll('[data-favorite-toggle]').forEach(function (btn) {
      var handle = btn.dataset.productHandle;
      var active = isFavorite(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = btn.querySelector('[data-favorite-label]');
      if (label) label.textContent = active ? 'Favorilerden çıkar' : 'Favorilere ekle';
    });
    var countBadge = document.querySelector('[data-favorites-count]');
    if (countBadge) {
      var n = getFavorites().length;
      countBadge.textContent = n;
      countBadge.hidden = n === 0;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-favorite-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.dataset.productHandle;
    if (!handle) return;
    toggleFavorite(handle);
    syncButtons();
  });

  syncButtons();

  // Favoriler sayfası: kayıtlı ürünleri Section Rendering API ile çek
  var grid = document.getElementById('favorites-grid');
  var emptyEl = document.getElementById('favorites-empty');
  if (grid) {
    var handles = getFavorites();
    if (handles.length === 0) {
      if (emptyEl) emptyEl.hidden = false;
    } else {
      var loaded = 0;
      handles.forEach(function (handle) {
        fetch('/products/' + handle + '?section_id=favorite-card-render')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var card = doc.querySelector('.product-card');
            if (card) grid.appendChild(card);
          })
          .catch(function () {})
          .finally(function () {
            loaded++;
            if (loaded === handles.length && grid.children.length === 0 && emptyEl) {
              emptyEl.hidden = false;
            }
          });
      });
    }
  }
})();
